/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import NumberFormat from 'react-number-format';

import { RenderTextField } from './FormTextField';
import { Field } from 'formik';
import maskUtils from 'commons/utils/maskUtils';

export const NumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, decimalScale, prefix, suffix, allowNegative, ...other } = props;
  const moneyMaskSettings = maskUtils.getMoneyMaskSettings();
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: other.name,
            value: values.value,
          },
        });
      }}
      prefix={prefix != null ? prefix : moneyMaskSettings.unit ?? 'R$'}
      decimalSeparator={moneyMaskSettings.separator}
      thousandSeparator={moneyMaskSettings.delimiter}
      decimalScale={decimalScale != null ? decimalScale : moneyMaskSettings.precision ?? 2}
      suffix={suffix ?? ''}
      fixedDecimalScale
      isNumericString
      allowNegative={allowNegative}
    />
  );
});

const FormNumberFormatField = ({
  name,
  type,
  placeholder,
  decimalScale,
  allowNegative,
  prefix,
  suffix,
  inputProps,
  containerClass,
  ...others
}) => {
  return (
    <Field
      name={name}
      component={RenderTextField}
      className={containerClass}
      inputProps={{
        inputComponent: NumberFormatCustom,
        placeholder: placeholder,
        inputProps: { decimalScale, prefix, suffix, allowNegative, ...inputProps },
      }}
      {...others}
    />
  );
};

export { FormNumberFormatField };
